<template>
	<div class="c-scroll-list" @scroll="scrollHandle">
		<slot v-for="(item, i) in dataList" :data="item" :index="i"></slot>
		<c-empty v-if="emptyState"></c-empty>
		<div v-else ref="loading" class="c-scroll-list-loading flex-row flex-center">
			<p v-if="endState">已经到底了</p>
			<p v-else class="flex-center"><i class="c-icon-loading"></i>正在加载...</p>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'cScrollList',

		props: {
			pageParam: { // 页数参数名
				type: [String, Number],
				default: 'pageIndex'
			},
			
			sizeParam: { // 分页大小参数名
				type: [String, Number],
				default: 'pageSize'
			},
			
			pageSize: { // 分页大小
				type: [String, Number],
				default: 10
			}
		},
		
		data() {
			return {
				endState: false,
				emptyState: false,
				dataList: [],
				pageIndex: 1,
				total: 0
			}
		},

		computed: {
			pageCount() {
				return Math.ceil(parseInt(this.total) / this.pageSize) || 1;
			},

			pageData() {
				return {
					pageIndex: Math.min(this.pageIndex, this.pageCount),
					pageSize: this.pageSize,
					pageCount: this.pageCount,
					total: this.total
				}
			}
		},

		watch: {
			dataList: {
				handler(val) {
					this.$emit('update', val);
				},
				deep: true
			},

			pageData: {
				handler(val) {
					this.$emit('updatePage', val);
				},
				immediate: true
			}
		},

		activated() {
			this.$nextTick(() => {
				if (this._scrollLastTop) {
					this.$el.scrollTo(0, this._scrollLastTop);
				}
			})
		},

		methods: {
			scrollHandle() {
				if (!this._requestObj && this.$refs.loading && this.$refs.loading.getBoundingClientRect().top < this.$el.getBoundingClientRect().bottom + this.$el.getBoundingClientRect().height * 0.5) {
					this.loadData();
				}
				if (this.$el.scrollTop != this._scrollLastTop) {
					this.$emit('scroll', {
						top: this.$el.scrollTop,
						direction: this.$el.scrollTop > this._scrollLastTop ? 'down' : 'up'
					});
				}
				this._scrollLastTop = this.$el.scrollTop;
			},
			
			getData() {
				return this.dataList;
			},

			// 加载数据
			load(option) {
				this._option = option;
				this.reload();
			},

			// 重载数据
			reload() {
				this.endState = false;
				this.emptyState = false;
				this.pageIndex = 0;

				if (this._requestObj) {
					this._requestObj.abort();
					this._requestObj = null;
				}
				
				this.dataList = [];
				this.loadData();
			},

			// 刷新已加载数据
			update() {
				if (this._requestObj) {
					this._requestObj.abort();
					this._requestObj = null;
				}
				this.loadData({
					pageSize: this.pageIndex * this.pageSize
				});
			},

			loadData(update) {
				if (this._requestObj || (this.endState && !update)) return;
				let pageIndex = update ? 1 : ++this.pageIndex, pageSize = update ? update.pageSize : this.pageSize;
				this._requestObj = this.request({
					url: this._option.url,
					data: Object.assign({}, this._option.data, {
						[this.sizeParam]: pageSize,
						[this.pageParam]: pageIndex
					}),
					success: data => {
						var list = this._option.dataFormatter ? this._option.dataFormatter(data, pageIndex) : data,
							total = this._option.parseTotal ? this._option.parseTotal(data, pageIndex) : (list ? list.length : 0),
							empty = (this._option.parseEmpty ? this._option.parseEmpty(data, pageIndex) : total) == 0;

						if (update) {
							let timestamp = new Date().getTime();
							this.dataList = list.map(item => {
								item._timestamp = timestamp;
								return item;
							});
							return;
						}

						if (!empty) {
							let timestamp = new Date().getTime();
							this.dataList = this.dataList.concat(list.map(item => {
								item._timestamp = timestamp;
								return item;
							}));
						} else {
							if (pageIndex == 1) {
								this.emptyState = true;
							}
						}
						
						this.$emit('afterLoad', list, pageIndex, data);

						if (total < pageSize) {
							this.endState = true;
							this.$emit('afterEnd');
						}
					},
					fail: () => {
						if (pageIndex == 1) {
							this.emptyState = true;
						}
						this.endState = true;
					},
					complete: () => {
						this._requestObj = null;
					},
					response: res => {
						this.total = this._option.totalFormatter ? this._option.totalFormatter(res) : res.total;
						this._option.response && this._option.response(res);
					}
				});
			},

			setData(data = []) {
				this.dataList = data;
				this.emptyState = !data.length;
				this.endState = true;
			},
			
			delete(index) {
				this.dataList.splice(index, 1);
			}
		}
	};
</script>

<style lang="stylus" scoped>
	.c-scroll-list {
		position: relative;
		overflow: auto;

		>>> .c-empty {
			position: absolute;
			left: 0;
			right: 0;
			top: 50%;
			transform: translate(0, -50%);
		}
		
		&-loading {
			width: 100%;
			height: 50px;
			font-size: 13px;
			color: #999;
			
			.c-icon-loading {
				margin-right: 8px;
			}
		}
	}
</style>